import React from 'react';
import {GridCell, gridConstants} from "../Grid";
import {Link} from "../Link";
import {icons} from './tileConstants';

interface TileProps {
    children?: React.ReactNode;
    iconName: string;
    isClickable?: boolean;
    label?: string;
    large_columns?: string;
    medium_columns?: string;
    to?: string;
    displayLogo?: boolean;
}

export const Tile: React.FC<TileProps> = ({
                         children,
                         iconName,
                         isClickable = true,
                         label,
                         large_columns = gridConstants.column.FOUR,
                         medium_columns = gridConstants.column.SIX,
                         to,
                         displayLogo = true,
                     }: TileProps) => {

    const classes = isClickable ? `tile is-clickable` : `tile tile--disabled`;
    const icon = (icons as Record<string, string>)[iconName] || (icons as Record<string, string>)[`Loan-Library`];

    return <>
        <GridCell large_columns={large_columns} medium_columns={medium_columns}>
            <Link to={isClickable ? to : undefined} className={classes}>
                {
                    displayLogo &&
                    <img
                        src={icon}
                        alt={``}
                        className="tile__icon"
                    />
                }
                <div className={"tile__header"}>
                    {label}
                </div>
                <div className={"tile__content"}>
                    {children}
                </div>
            </Link>
        </GridCell>
    </>;
};
